export const widthCanvas = 794;
export const heightCanvas = 1123;

// PUNTOS
// export const widthCanvas = 595;
// export const heightCanvas = 841;

